import clsx from 'clsx';

const ParagraphField = ( { field } ) => {

    const { title, cssclass } = field;

    return (
        <div
            className={ clsx(
                'thwcfd-paragraph-field',
                cssclass?.split( ',' ).map( ( c ) => c.trim() )
            ) }
        >
            <p className="thwcfd-paragraph-text">
                { title || '' }
            </p>
        </div>
    );
};

export default ParagraphField;